import { Navigate, Route, Routes } from 'react-router';
import { RequireAuth } from './auth/RequireAuth';
import { Login } from './features/auth/Login';
import { Signup } from './features/auth/Signup';
import { JoinScreen } from './features/join/JoinScreen';
import { ListDetailScreen } from './features/list-detail/ListDetailScreen';
import { ListsScreen } from './features/lists/ListsScreen';

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/signup" element={<Signup />} />
      <Route
        path="/"
        element={
          <RequireAuth>
            <ListsScreen />
          </RequireAuth>
        }
      />
      <Route
        path="/lists/:id"
        element={
          <RequireAuth>
            <ListDetailScreen />
          </RequireAuth>
        }
      />
      <Route
        path="/join/:token"
        element={
          <RequireAuth>
            <JoinScreen />
          </RequireAuth>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
